module.exports = __webpack_public_path__ + "img/prof3.935b56da.jpg";